import React from 'react';
import './ProfileWidget.scss';

function WorkReportTab({ employeeDetails }) {
  return (
    <div className="profile-widget-tab">
      <div
        className="d-flex flex-row justify-content-between"
        title="Your assigned cost center for internal budgeting and accounting."
      >
        <span className="profile-widget-label">Cost Center</span>
        <span className="profile-widget-value fw-semibold">
          {employeeDetails?.[0]?.CostCenter}
        </span>
      </div>
      <div
        className="d-flex flex-row justify-content-between"
        title="Your current department"
      >
        <span className="profile-widget-label">Department</span>
        <span className="profile-widget-value fw-semibold">
          {employeeDetails?.[0]?.Department}
        </span>
      </div>
      <div
        className="d-flex flex-row justify-content-between"
        title="Subdivision or section under your department."
      >
        <span className="profile-widget-label">Section</span>
        <span className="profile-widget-value fw-semibold">
          {employeeDetails?.[0]?.Section}
        </span>
      </div>
      <div
        className="d-flex flex-row justify-content-between"
        title="The manager or supervisor you report to."
      >
        <span className="profile-widget-label">Reports To</span>
        <span className="profile-widget-value fw-semibold">
          {employeeDetails?.[0]?.ReportsTo}
        </span>
      </div>
      <div
        className="d-flex flex-row justify-content-between"
        title="Your official date of joining"
      >
        <span className="profile-widget-label">Hire Date</span>
        <span className="profile-widget-value fw-semibold">
          {employeeDetails?.[0]?.HireDate}
        </span>
      </div>
      <div
        className="d-flex flex-row justify-content-between"
        title="The company entity or legal unit you belong to."
      >
        <span className="profile-widget-label">Entity</span>
        <span className="profile-widget-value fw-semibold">
          {employeeDetails?.[0]?.Entity}
        </span>
      </div>
    </div>
  );
}

export default WorkReportTab;
